// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__3SY9H","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__6cQ6B"};